import { probeSession } from '@features/auth/api/probe-session';
import WarningState from '@features/auth/components/warning-state';
import Dialog from '@mui/material/Dialog';
import useLogout from '@src/hooks/use-logout';
import { useSessionStore } from '@src/stores/use-session-store';
import { StyledPaper } from '@styled/styled-paper';
import React, { useEffect } from 'react';

export function SessionTimeoutCountdown() {
  const showAlert = useSessionStore.use.showAlert();
  const sessionStatus = useSessionStore.use.sessionStatus();
  const timeUntilSessionExpires =
    useSessionStore.use.secondsUntilSessionExpires();
  const { handleLogout } = useLogout();
  const [submitting, setSubmitting] = React.useState(false);

  const handleStaySignedIn = async () => {
    setSubmitting(true);
    await probeSession();
    setSubmitting(false);
  };

  useEffect(() => {
    if (sessionStatus === 'warning' && timeUntilSessionExpires === 0) {
      handleLogout();
    }
  }, [sessionStatus, timeUntilSessionExpires]);

  // Probe on tab return only. We deliberately do NOT probe when the countdown
  // naturally fires (showAlert -> true): the response interceptor would see a
  // 200, re-anchor the timer, and silently dismiss the warning the user was
  // meant to read. The bug we're fixing is the stale-after-tab-switch case,
  // which is exactly what visibilitychange catches.
  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === 'visible') {
        void probeSession();
      }
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
  }, []);

  const open = sessionStatus === 'warning' && showAlert;

  return (
    <Dialog open={open}>
      <StyledPaper>
        <WarningState
          timeUntilSessionExpires={timeUntilSessionExpires}
          submitting={submitting}
          onSignOut={handleLogout}
          onStay={handleStaySignedIn}
        />
      </StyledPaper>
    </Dialog>
  );
}
